import React from "react";
import App from "container/App";
import { Provider } from "react-redux";
import config from "lib/fr-config";
import configure from "store/configure";
import CssBaseline from "@material-ui/core/CssBaseline"; // reset.css
import { MuiThemeProvider, createTheme } from "@material-ui/core/styles";

const colorCss = config.css.color;
const fontFamilyCss = config.css.fontFamily;

const store = configure;

const theme = createTheme({
  props: {
    MuiButtonBase: {
      disableRipple: true // 물결현상 제거.
    }
  },
  palette: {
    primary: { main: colorCss.colorOfPrimary },
    secondary: { main: colorCss.colorOfSecondary }
  },
  typography: {
    // https://material-ui.com/style/typography/#migration-to-typography-v2
    fontFamily: fontFamilyCss
  },
  overrides: {
    MuiPaper: { root: { backgroundColor: colorCss.colorOfBackground } },
    MuiBackdrop: {
      root: { backgroundColor: colorCss.backgroundColorOfModal }
    },
    MuiButton: {
      root: {
        textTransform: "none",
        whiteSpace: "nowrap",
        "&$disabled": {
          color: colorCss.colorOfDisabled
        }
      },
      contained: {
        boxShadow: "none",
        borderRadius: 0
      },
      text: {
        borderRadius: 0
      }
    },
    MuiInputBase: {
      input: {
        "&::placeholder": {
          color: colorCss.colorOfSecondary
        }
      }
    },
    MuiListItemText: {
      root: {
        padding: 0
      }
    }
  }
});

function Root(props) {
  return (
    <div style={{ backgroundColor: colorCss.colorOfBackground }}>
      <CssBaseline />
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <App />
        </Provider>
      </MuiThemeProvider>
    </div>
  );
}

export default Root;
